var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createApp, defineComponent, reactive } from 'vue';
import Login from "../../models/api/v1/modal/Login";
import { signInForm, errorSignIn } from "../../types/front/TSignInForm";
const App = defineComponent({
    setup() {
        let form = reactive(signInForm);
        let error = reactive(errorSignIn);
        const onLogin = () => __awaiter(this, void 0, void 0, function* () {
            let response = yield Login.handleLogin({ email: form.email, password: form.password });
            const errorResponse = response.data.errors;
            Object
                .keys(error)
                .forEach((key) => {
                if (errorResponse && errorResponse[key] && errorResponse[key][0]) {
                    // @ts-ignore
                    error[key] = errorResponse[key][0];
                }
                else {
                    // @ts-ignore
                    error[key] = '';
                }
            });
            if (response.data.success) {
                window.location.reload();
            }
        });
        return {
            onLogin,
            form,
            error
        };
    }
});
window.addEventListener('DOMContentLoaded', (ev) => {
    createApp(App).mount('#common');
});
